import { Markdown } from "components/Markdown"
import PropTypes from "prop-types"
import { useMemo } from "react"
import { urlRegex } from "utils/regex"

export const Description = ({ children: childrenProps }) => {
  const children = useMemo(
    () => replaceUrlsByLinks(childrenProps),
    [childrenProps],
  )

  return <Markdown>{children}</Markdown>
}

Description.propTypes = {
  children: PropTypes.string.isRequired,
}

const globalUrlRegex = new RegExp(urlRegex, "g")

const replaceUrlsByLinks = (str) => {
  return str.replace(globalUrlRegex, urlToMarkdown)
}

const urlToMarkdown = (url) => {
  const fullURL = url.startsWith("http") ? url : `https://${url}`

  return `[${url}](${fullURL})`
}
